<script lang="ts">
    
    import { SERVICE_URL } from "../../evironment";

    export let signId: string | null;

</script>

{#if signId}
    <img src={`${SERVICE_URL}/sign/${signId}`} alt="">
{/if}

<style lang="scss">

    img {
        max-width: 100%;
    }

</style>
